import type { ReactNode } from "react";

export function DashboardEmptyState({ icon, message }: { icon: ReactNode; message: string }) {
  return (
    <div className="flex flex-col items-center gap-2 py-12">
      {icon}
      <p className="text-sm text-[#AAAAAA]">{message}</p>
    </div>
  );
}
